module.exports = __webpack_public_path__ + "media/images/site/fundamental2_large-064cbaa774eba69d79c462596cd4ad9c.jpg";